$(document).ready(function () {

  /* scroll to target */
  jQuery('.scrollTo').click(function (e) {
    var jump = jQuery(this).attr('href');
    var new_position = jQuery(jump).offset();
    jQuery('html, body').stop().animate({ scrollTop: new_position.top }, 800);
    e.preventDefault();
  });

  /* initialize fancybox */
  $(".fancybox").fancybox();


  /*faq*/
  $('.accord:nth-child(1)').addClass('openaccord');
  $('.accord:nth-child(1) .accord-title').addClass('close-slide');
  $(".accord-title").click(function () {
    $(this).toggleClass("close-slide");
    $(this).next(".accord-body").slideToggle();
    $(".accord-body").not($(this).next(".accord-body")).slideUp();
    $(".accord-title").not($(this)).removeClass("close-slide");
    $(this).parent().toggleClass('openaccord');
    $(this).parent().siblings().removeClass('openaccord');
  });

  document.addEventListener('lazybeforeunveil', function (e) {
    var bg = e.target.getAttribute('data-bg');
    if (bg) {
      e.target.style.backgroundImage = 'url(' + bg + ')';
    }
  });

  /*$('.gocheck').on('click', function (e) {
    e.preventDefault();
    var target = this.hash;
    var $target = $(target);
    $('html, body').stop().animate({
      'scrollTop': $target.offset().top
    }, 900, 'swing', function () {
      // window.location.hash = target;
    });
  });*/

  $('.rowgap h3').matchHeight({ byRow: true });

  $('.productwrap  .productname').matchHeight({ byRow: true });





  $('.logoslide').slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: "<i class='fas fa-chevron-left left'></i>",
    nextArrow: "<i class='fas fa-chevron-right right'></i>",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        }
      },
    ]
  });

  $('.dmslide').slick({
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: "<i class='fas fa-chevron-left left'></i>",
    nextArrow: "<i class='fas fa-chevron-right right'></i>",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        }
      },
    ]
  });


  var slide = $('.slidebooks');
  slide.on('init afterChange', function (event, slick) {
    slide.find('.slick-active').last().addClass('last-active');
  });

  slide.slick({
    dots: false,
    infinite: false,
    slidesToShow: 3.7,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: "<i class='fas fa-chevron-left left'></i>",
    nextArrow: "<i class='fas fa-chevron-right right'></i>",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2.7,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1.7,
        }
      },
    ]
  });

  $('body').on('click', '.slidebooks .slick-arrow.right', function () {
    setTimeout(function () {
      var lastac = slide.find('.slick-active').last();
      if (lastac.next().length > 0) {
        lastac.prev().removeClass('last-active');
      }
    }, 500)


  });

  var $slider = $('.reviewsllides');
  var currentSlide;
  var slidesCount;
  var sliderCounter = document.createElement('div');
  sliderCounter.classList.add('slider__counter');

  var updateSliderCounter = function (slick, currentIndex) {
    currentSlide = slick.slickCurrentSlide() + 1;
    var count1 = currentSlide < 9 ? '0' + currentSlide : currentSlide;
    slidesCount = slick.slideCount;
    var count2 = slidesCount < 9 ? '0' + slidesCount : slidesCount;
    $(sliderCounter).text(count1 + '/' + count2);
  };
  $slider.on('init afterChange', function (event, slick) {
    $slider.append(sliderCounter);
    updateSliderCounter(slick);
  });

  $slider.slick({
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: "<i class='material-icons left'>arrow_forward</i>",
    nextArrow: "<i class='material-icons right'>arrow_forward</i>",
    lazyLoad: "ondemand",
    autoplay: true,
  })

  
  var $slider1 = $('.videosllides');
  var currentSlide1;
  var slidesCount1;
  var sliderCounter1 = document.createElement('div');
  sliderCounter1.classList.add('slider__counter');

  var updateSliderCounter1 = function (slick, currentIndex) {
    currentSlide1 = slick.slickCurrentSlide() + 1;
    var count11 = currentSlide1 < 9 ? '0' + currentSlide1 : currentSlide1;
    slidesCount1 = slick.slideCount;
    var count21 = slidesCount1 < 9 ? '0' + slidesCount1 : slidesCount1;
    $(sliderCounter1).text(count11 + '/' + count21);
  };
  $slider1.on('init afterChange', function (event, slick) {
    $slider1.append(sliderCounter1);
    updateSliderCounter1(slick);
  });

  $slider1.slick({
    dots: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: "<i class='material-icons left'>arrow_forward</i>",
    nextArrow: "<i class='material-icons right'>arrow_forward</i>",
    lazyLoad: "ondemand",
  })



  String.prototype.getDecimals || (String.prototype.getDecimals = function () {
    var a = this,
      b = ("" + a).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    return b ? Math.max(0, (b[1] ? b[1].length : 0) - (b[2] ? +b[2] : 0)) : 0
  });
  jQuery(document).on("click", ".plus, .minus", function () {
    var a = jQuery(this).closest(".quantity").find(".qty"),
      b = parseFloat(a.val()),
      c = parseFloat(a.attr("max")),
      d = parseFloat(a.attr("min")),
      e = a.attr("step");
    b && "" !== b && "NaN" !== b || (b = 0), "" !== c && "NaN" !== c || (c = ""), "" !== d && "NaN" !== d || (d = 0), "any" !== e && "" !== e && void 0 !== e && "NaN" !== parseFloat(e) || (e = 1), jQuery(this).is(".plus") ? c && b >= c ? a.val(c) : a.val((b + parseFloat(e)).toFixed(e.getDecimals())) : d && b <= d ? a.val(d) : b > 0 && a.val((b - parseFloat(e)).toFixed(e.getDecimals())), a.trigger("change")
    a.attr('value', a.val());
  });

  $('.mobile-trigger').click(function () {
    $(this).toggleClass('active-re');
    $('#navbarsId').slideToggle();
  });
  
  

});

